export default __webpack_public_path__ + "static/SRUS AP680 - Product Specifications & Technical Data-992253786aff76546f62d4caaac691ab.pdf";